<template>
	<a class="apple float-left flex justify-center vertical-align borderRadius8" alt="Sign In Using Apple Auth" @click="comingSoon()">
		<i></i> 
		Sign in with Apple
	</a>
</template>

<script>
	
	// Import firebase services
	import firebase from 'firebase/app'
    import { firebaseAuth, usersModel } from '@/firebase/firebase-config'

	// Import the mixins
	import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'
	import { SpinnerMethods } from '@/mixins/helpers/SpinnerMethods'

	export default {

		/*
		** Set the component name
		*/

		name: 'AppleAuthSignInButton',

		/*
		**  Register the mixins
		*/

		mixins: [

			BugsnagService,
			SpinnerMethods

		],

		/*
		**  Set up the data
		*/

		data: () => ({

			apple_user: null,
			apple_provider: null

		}),

		/*
		**  Set up the methods
		*/

		methods: {

			comingSoon: function() {

				// Throw the message
				this.$swal('Coming Soon', 'This sign in option is being worked on at the moment. Please stay tuned.', 'info');

			},

			setProvider: function() {

				// Set the provider
				this.apple_provider = new firebase.auth.OAuthProvider('apple.com');

				// Add the scopes
				this.apple_provider.addScope('email');
				this.apple_provider.addScope('name');

			},

			signInWithPopUp: function() {

				// Set the provider
				this.setProvider();

				// Trigger pop up
				firebaseAuth.signInWithPopup(this.apple_provider)
				.then(function(result) {

					// Store the data
					this.apple_user = result.user;

				}.bind(this))
				.then(() => {

					if (this.apple_user) {

						// Check if user exists
						this.userCheck();

					} else {

						// Throw error message
						this.$swal('Uh Oh!', 'Looks like we ran into the following issue when signing you in.', 'error');

					}

				})
				.catch(function(error) {

					// Throw error message
					this.$swal('Uh Oh!', 'Looks like we ran into the following issue when signing you in. More details: ' + error.message, 'error');

					// Send to bugsnag
					this.reportCustomBugsnagError({
						title: 'SISU - Apple Auth Sign In With Pop Up',
						errorType: 'Firebase Auth',
						section: 'SISU',
						component: 'AppleAuthSignInButton',
						error: error,
						custom: {
							errorCode: error.code,
							errorMessage: error.message,
							userEmail: error.email,
							credentialType: error.credential
						}
					});

				}.bind(this));

			},

			userCheck: function() {

				// Get the user doc
				usersModel.doc(this.apple_user.uid).get()
				.then(doc => {

					// Log em' in
					if (doc.exists) {

						// Hide the spinner
						this.hideSpinner();

						// Redirect to For You page
						this.$router.push({ name: 'Dashboard' });

					} else {

						if (firebaseAuth.currentUser) {

							// Sign the user out
							firebaseAuth.signOut()
							.then(() => {

								// Redirect to sign up page
								this.$router.push({ name: 'SignUp' });

								// Throw error message
						    	this.$swal('Uh Oh!', 'Please create an account before signing in.', 'error');

							});

							return;

						}

						// Redirect to sign up page
						this.$router.push({ name: 'SignUp' });

						// Throw error message
				    	this.$swal('Uh Oh!', 'Please create an account before signing in.', 'error');

					};

				})
				.catch(error => {

					// Send to bugsnag
					this.reportNoAuthBugsnagError({
						title: 'SISU - Apple Sign In User Check',
						errorType: 'Firestore Database',
						section: 'SISU',
						component: 'AppleAuthSignInButton',
						error: error
					});

				});

			}

		}

	}

</script>